"use client";
import LoginSection from "@/components/section/auth/login-section"; 
import { initAuthListener } from "@/store/useAuthStore";
import { useEffect, useState } from "react";

export default function Page() {
  useEffect(() => {
    initAuthListener();
  }, []);

  return (
    <div className="">
      <LoginSection />
    </div>
  );
}
